/**
 * Shared logic for CarrierGroupsTable drag-and-drop and group actions.
 * Import and use these functions in any component that uses CarrierGroupsTable.
 */

export function dragStart(context, index) {
  context.draggedItemIndex = index;
}

export function drop(context, index) {
  if (index === context.draggedItemIndex) {
    context.draggedItemIndex = null;
    return;
  }
  if (context.draggedItemIndex !== null) {
    const draggedItem = context.groups[context.draggedItemIndex];
    draggedItem.order = index + 1;
    context.groups.splice(context.draggedItemIndex, 1);
    context.groups.splice(index, 0, draggedItem);
  }
  context.draggedItemIndex = null;

  // Update order for all items
  context.groups.forEach((group, idx) => {
    group.order = idx + 1;
  });

  context.isSaving = true;
  context.isSorting = true;

  // Build array for batch sort
  const sortedGroups = context.groups.map((group, idx) => ({
    id: group.id,
    order: idx + 1
  }));

  context.$http
    .post('/api/carrier-groupings/sort', sortedGroups)
    .catch(err => {
      if (context.$EventBus) {
        context.$EventBus.$emit('show-error', err);
      }
    })
    .finally(() => {
      context.isSaving = false;
      context.isSorting = false;
    });
}

export function selectGroup(context, group) {
  context.option = group.id;
  context.form = { ...group };
  context.isNew = false;
}

export function onDeleteGroup(context, group) {
  context.form = { ...group };
  if (typeof context.onDelete === "function") {
    context.onDelete();
  }
}
